import script from "./GraphPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GraphPanel.vue?vue&type=script&setup=true&lang=ts"

import "./GraphPanel.vue?vue&type=style&index=0&id=3d05c775&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d05c775"]])

export default __exports__